var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择"},on:{"visible-change":_vm.server,"change":_vm.handleCarSize},model:{value:(_vm.carSizeId),callback:function ($$v) {_vm.carSizeId=$$v},expression:"carSizeId"}},_vm._l((_vm.carSizeTable),function(item,index){return _c('el-option',{key:index,attrs:{"value":item.Id,"label":item.Name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }